export const SET_HRES35U_INDEX_DISP = 'SET_HRES35U_INDEX_DISP'
export const GET_HRES35U_INDEX_DISP = 'GET_HRES35U_INDEX_DISP'
export const SET_HRES35U_DETAIL_DISP = 'SET_HRES35U_DETAIL_DISP'
export const GET_HRES35U_DETAIL_DISP = 'GET_HRES35U_DETAIL_DISP'
export const SET_HRES35U_MAX_ROWSPAN = 'SET_HRES35U_MAX_ROWSPAN'
export const GET_HRES35U_MAX_ROWSPAN = 'GET_HRES35U_MAX_ROWSPAN'
export const SET_HRES35U_COLUMNS = 'SET_HRES35U_COLUMNS'
export const GET_HRES35U_COLUMNS = 'GET_HRES35U_COLUMNS'
export const SET_HRES35U_LABELS = 'SET_HRES35U_LABELS'
export const GET_HRES35U_LABELS = 'GET_HRES35U_LABELS'
export const RECEIVED_HRES35U_COLUMNS_LABELS = 'RECEIVED_HRES35U_COLUMNS_LABELS'
export const SET_HRES35U_INDEX = 'SET_HRES35U_INDEX'
export const GET_HRES35U_INDEX = 'GET_HRES35U_INDEX'
export const RECEIVED_HRES35U_INDEX = 'RECEIVED_HRES35U_INDEX'
export const SET_HRES35U_INDEX_SELECTED = 'SET_HRES35U_INDEX_SELECTED'
export const GET_HRES35U_INDEX_SELECTED = 'GET_HRES35U_INDEX_SELECTED'
export const SET_HRES35U_DETAIL = 'SET_HRES35U_DETAIL'
export const GET_HRES35U_DETAIL = 'GET_HRES35U_DETAIL'
export const RECEIVED_HRES35U_DETAIL = 'RECEIVED_HRES35U_DETAIL'
export const TOGGLE_HRES35U_PAGE = 'TOGGLE_HRES35U_PAGE'
export const POST_HRES35U_SEND_APPROVE = 'POST_HRES35U_SEND_APPROVE'
export const RECEIVED_HRES35U_DROPDOWNS = 'RECEIVED_HRES35U_DROPDOWNS'
export const SET_HRES35U_DROPDOWNS = 'SET_HRES35U_DROPDOWNS'
export const GET_HRES35U_DROPDOWNS = 'GET_HRES35U_DROPDOWNS'



// WEBPACK FOOTER //
// ./src/store/modules/hres35u/mutation-types.js